export const API_PATH_ApiTrafficStudiesSearchGet = '/services/traffic-studies/apiTrafficStudiesSearchGet';
